import React from 'react';

export const BodyArmIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M64.1035 93.652L28.4181 93.652C13.5743 93.652 6.29119 81.594 6.44542 71.875C6.44542 61.2302 21.5821 22.2654 21.5821 22.2654C24.1212 15.9177 26.3167 10.7183 33.7892 10.8395C39.5509 10.8395 50.6349 15.527 50.6349 24.902C50.6349 29.9802 47.0704 31.4938 47.0704 31.4938C47.0704 34.5212 44.5802 37.402 41.9435 37.402H30.2735C30.2735 37.402 40.0788 57.0829 40.9181 58.6422C41.7574 60.2016 42.5782 58.6422 42.5782 58.6422C45.8985 48.5348 57.0314 40.6061 66.8946 40.6061C80.9211 40.6027 93.7483 53.1717 93.7501 64.9005C93.7501 64.8992 93.7501 64.898 93.7501 64.8968V64.903C93.7501 64.9022 93.7501 64.9013 93.7501 64.9005C93.7485 79.7871 83.8852 93.652 64.1035 93.652Z"
        fill="#FFC83D"
      />
      <path
        d="M93.7501 64.903V64.8968C93.7501 64.898 93.7501 64.8992 93.7501 64.9005C93.7501 64.9013 93.7501 64.9022 93.7501 64.903Z"
        fill="#FFC83D"
      />
      <path
        d="M32.0312 20.1173L36.084 25.2687H42.627C41.1621 23.2668 36.0156 19.4142 32.0312 20.1173Z"
        fill="#D67D00"
      />
      <path
        d="M47.1138 31.4745C47.0855 31.4879 47.0703 31.4944 47.0703 31.4944C47.0703 34.5217 44.5801 37.4026 41.9434 37.4026H30.7239C30.7239 37.4026 32.0286 40.4236 33.6594 44.1923C24.8812 43.4631 21.875 34.3508 21.875 34.3508H24.4203C24.4534 34.3664 24.4868 34.3827 24.5205 34.3996H41.1133C42.7734 34.3996 46.3867 32.9104 43.7988 28.1252C44.7035 28.1252 46.6052 29.4958 47.1138 31.4745Z"
        fill="#D67D00"
      />
      <path
        d="M45.7856 58.4432C45.2019 57.4814 44.3579 56.827 43.4202 56.4804C43.1008 57.1883 42.8189 57.9098 42.5781 58.6427C42.5781 58.6427 42.2842 59.2011 41.8682 59.3154C42.3535 59.3429 42.8278 59.5928 43.1142 60.0647L52.3752 75.3226C52.823 76.0603 53.784 76.2953 54.5217 75.8476C55.2594 75.3998 55.4944 74.4388 55.0467 73.7011L45.7856 58.4432Z"
        fill="#D67D00"
      />
      <path
        d="M37.7864 58.4187C38.3137 57.5618 39.0475 56.952 39.8689 56.5889C40.4036 57.648 40.7807 58.3877 40.918 58.6427C41.1542 59.0815 41.3889 59.2734 41.6043 59.3225C41.1521 59.3723 40.7184 59.6168 40.4478 60.0565L31.4088 74.7448C30.9566 75.4797 29.9942 75.7089 29.2592 75.2566C28.5243 74.8044 28.2951 73.8419 28.7474 73.107L37.7864 58.4187Z"
        fill="#D67D00"
      />
    </svg>
  );
};
